import { DataTypeKey, ModuleKey } from './types';

export interface ModuleDef {
  key: ModuleKey;
  labelKey: string;
  /** What this module does with the data below it. The bare module name does not say. */
  descriptionKey: string;
}

export interface DataTypeDef {
  key: DataTypeKey;
  module: ModuleKey;
  labelKey: string;
  /** One short sentence naming what Mowazaf does with this data. Shown as a row tooltip. */
  descriptionKey: string;
  /** Employees underpins everything else, so its row says so. */
  foundational: boolean;
}

// Only modules that consume a data type Mowazaf actually imports appear here. Adding a module
// without a real consumer would advertise capability the product does not have.
export const MODULES: ModuleDef[] = [
  { key: 'coreHr', labelKey: 'extInt.module.coreHr', descriptionKey: 'extInt.module.coreHr.description' },
  { key: 'employeeImpact', labelKey: 'extInt.module.employeeImpact', descriptionKey: 'extInt.module.employeeImpact.description' },
  { key: 'assets', labelKey: 'extInt.module.assets', descriptionKey: 'extInt.module.assets.description' },
];

export const DATA_TYPES: DataTypeDef[] = [
  {
    key: 'employees',
    module: 'coreHr',
    labelKey: 'extInt.dataType.employees',
    descriptionKey: 'extInt.dataType.employees.description',
    foundational: true,
  },
  {
    key: 'departments',
    module: 'coreHr',
    labelKey: 'extInt.dataType.departments',
    descriptionKey: 'extInt.dataType.departments.description',
    foundational: false,
  },
  {
    key: 'jobRoles',
    module: 'coreHr',
    labelKey: 'extInt.dataType.jobRoles',
    descriptionKey: 'extInt.dataType.jobRoles.description',
    foundational: false,
  },
  {
    key: 'goals',
    module: 'employeeImpact',
    labelKey: 'extInt.dataType.goals',
    descriptionKey: 'extInt.dataType.goals.description',
    foundational: false,
  },
  {
    key: 'skills',
    module: 'employeeImpact',
    labelKey: 'extInt.dataType.skills',
    descriptionKey: 'extInt.dataType.skills.description',
    foundational: false,
  },
  {
    key: 'assets',
    module: 'assets',
    labelKey: 'extInt.dataType.assets',
    descriptionKey: 'extInt.dataType.assets.description',
    foundational: false,
  },
];

export const DATA_TYPE_ORDER: DataTypeKey[] = DATA_TYPES.map((d) => d.key);

export function getDataType(key: DataTypeKey): DataTypeDef {
  const found = DATA_TYPES.find((d) => d.key === key);
  if (!found) throw new Error(`Unknown data type ${key}`);
  return found;
}

/** Data types belonging to one module, in catalogue order. */
export function dataTypesForModule(module: ModuleKey): DataTypeDef[] {
  return DATA_TYPES.filter((d) => d.module === module);
}
